import React from 'react';
import { Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import FormHelper from 'helpers/FormHelper';
import FileList from 'components/fileList/index.';
import styles from '../../style.module.scss';
import { Descriptions } from 'antd';

const FileSection = ({ singleItem, loading, onDelete, isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item>
          <Form.Item
            className={styles.fileFormItem}
            name='files'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
          >
            <Upload.Dragger
              disabled={isView}
              multiple
              name='files'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'PDF', 'WORD', 'XLS', 'XLSX', 'PPTX', 'CSV'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  PDF WORD XLS XLSX PPTX CSV
                  </Descriptions.Item>
                  <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                  20MB
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <FileList
          loading={loading}
          onDelete={onDelete}
          hideDeleteBtn={isView}
          data={
            singleItem?.files?.map((i) => ({
              file: {
                ...i,
              },
            })) || []
          }
        />
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
